/* main js */
(function ($) {
    "use strict";

    /* Aos animation on scroll */
    AOS.init({
        once: true,
    });

    // On page load body easing animation
    function animateBody() {
  const bodyAnim = document.querySelector('.bb-anim-body');

  if (bodyAnim && !bodyAnim.classList.contains('bb-body-loaded')) {
    requestAnimationFrame(() => {
      bodyAnim.classList.add('bb-body-loaded');
    });
    return true;
  }

  return false;
}

/* If already exists */
if (!animateBody()) {
  const observer = new MutationObserver(function () {
    if (animateBody()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

    /* Responsive Mobile Menu */
    function ResponsiveMobilemsMenu() {
        var $msNav = $(".bb-menu-content, .overlay-menu"),
            $msNavSubMenu = $msNav.find(".sub-menu");
        $msNavSubMenu.parent().prepend('<span class="menu-toggle"></span>');

        $msNav.on("click", "li a, .menu-toggle", function (e) {
            var $this = $(this);
            if ($this.attr("href") === "#" || $this.hasClass("menu-toggle")) {
                e.preventDefault();
                if ($this.siblings("ul:visible").length) {
                    $this.parent("li").removeClass("active");
                    $this.siblings("ul").slideUp();
                    $this.parent("li").find("li").removeClass("active");
                    $this.parent("li").find("ul:visible").slideUp();
                } else {
                    $this.parent("li").addClass("active");
                    $this
                        .closest("li")
                        .siblings("li")
                        .removeClass("active")
                        .find("li")
                        .removeClass("active");
                    $this.closest("li").siblings("li").find("ul:visible").slideUp();
                    $this.siblings("ul").slideDown();
                }
            }
        });
    }

    ResponsiveMobilemsMenu();

    /* Custom select */
    $("select.formselect").each(function () {
        var $this = $(this),
            selectOptions = $(this).children("option").length;

        $this.addClass("hide-select");
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="custom-select active"></div>');

        var $customSelect = $this.next("div.custom-select.active");
        $customSelect.text($this.children("option").eq(0).text());

        var $optionlist = $("<ul />", {
            class: "select-options",
        }).insertAfter($customSelect);

        for (var i = 0; i < selectOptions; i++) {
            $("<li />", {
                text: $this.children("option").eq(i).text(),
                rel: $this.children("option").eq(i).val(),
            }).appendTo($optionlist);
        }

        var $optionlistItems = $optionlist.children("li");

        $customSelect.click(function (e) {
            e.stopPropagation();
            $("div.custom-select.active")
                .not(this)
                .each(function () {
                    $(this).removeClass("active").next("ul.select-options").hide();
                });
            $(this).toggleClass("active").next("ul.select-options").slideToggle();
        });

        $optionlistItems.click(function (e) {
            e.stopPropagation();
            $customSelect.text($(this).text()).removeClass("active");
            $this.val($(this).attr("rel"));
            $optionlist.hide();
        });

        $(document).click(function () {
            $customSelect.removeClass("active");
            $optionlist.hide();
        });
    });

    /* Hero Shape */
    var shape = "M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45 c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2 c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7 c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z; M51,171.3c-6.1-17.7-15.3-17.2-20.7-32c-8-21.9,0.7-54.6,20.7-67.1c19.5-12.3,32.8,5.5,67.7-3.4C145.2,62,145,49.9,173,43.4 c12-2.8,41.4-9.6,60.2,6.6c19,16.4,16.7,47.5,16,57.7c-1.7,22.8-10.3,25.5-9.4,46.4c1,22.5,11.2,25.8,9.1,42.6 c-2.2,17.6-16.3,37.5-33.5,40.8c-22,4.1-29.4-22.4-54.9-22.6c-31-0.2-40.8,39-68.3,35.7c-17.3-2-32.2-19.8-37.3-34.8 C48.9,198.6,57.8,191,51,171.3z; M37.5,186c-12.1-10.5-11.8-32.3-7.2-46.7c4.8-15,13.1-17.8,30.1-36.7C91,68.8,83.5,56.7,103.4,45 c22.2-13.1,51.1-9.5,69.6-1.6c18.1,7.8,15.7,15.3,43.3,33.2c28.8,18.8,37.2,14.3,46.7,27.9c15.6,22.3,6.4,53.3,4.4,60.2 c-3.3,11.2-7.1,23.9-18.5,32c-16.3,11.5-29.5,0.7-48.6,11c-16.2,8.7-12.6,19.7-28.2,33.2c-22.7,19.7-63.8,25.7-79.9,9.7 c-15.2-15.1,0.3-41.7-16.6-54.9C63,186,49.7,196.7,37.5,186z";
    $(window).on("load", function () {
        $(".animate-shape animate").attr('values', shape);
    });

    /* Category 6 colum slider section (Shop Page) */
    // $('.bb-category-6-colum').slick({
    //     slidesToShow: 6,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     infinite: true,
    //     speed: 500,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     pauseOnHover: true,

    //     responsive: [
    //         {
    //             breakpoint: 1400,
    //             settings: {
    //                 slidesToShow: 5
    //             }
    //         },
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 slidesToShow: 4
    //             }
    //         },
    //         {
    //             breakpoint: 992,
    //             settings: {
    //                 slidesToShow: 3
    //             }
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 2
    //             }
    //         },
    //         {
    //             breakpoint: 421,
    //             settings: {
    //                 slidesToShow: 1
    //             }
    //         }
    //     ]
    // });

    /* Remove product on wishlist page */
    $(".bb-remove-wish").on("click", function () {
        $(this).parents(".bb-wishlist").remove();
        var wish_product_count = $(".bb-wishlist").length;
        if (wish_product_count == 0) {
            $('.bb-wish-rightside').html('<p class="bb-wishlist-msg">Your wishlist is empty!</p>');
        }
    });

    /* Remove product on compare page */
    $(".bb-remove-compare").on("click", function () {
        $(this).parents(".bb-compare-box").remove();
    });

    /* Footer Toggle */
    $(document).ready(function () {
        $(".bb-footer-links").addClass("bb-footer-dropdown");

        $(".bb-footer-heading").append(
            "<div class='bb-heading-res'><i class='ri-arrow-down-s-line'></i></div>"
        );

        $(".bb-footer-heading .bb-heading-res").on("click", function () {
            var $this = $(this)
                .closest(".footer-top .col-sm-12")
                .find(".bb-footer-dropdown");
            $this.slideToggle("slow");
            $(".bb-footer-dropdown").not($this).slideUp("slow");
        });
    });

    /* Single Product Color and Size Click to Active  */
    function initShopUIHandlers() {
        // Single Product Color and Size Click to Active
        $(".bb-pro-variation ul li").off("click").on("click", function () {
            $(this).addClass("active").siblings().removeClass("active");
        });

        // active-tags
        $("ul.bb-shop-tags li").off("click").on("click", function () {
            $(this).addClass("active-tags").siblings().removeClass("active-tags");
        });

        // color-sidebar-active
        $(".bb-color-contact ul li").off("click").on("click", function () {
            $(this).addClass("color-sidebar-active").siblings().removeClass("color-sidebar-active");
        });

        // active-variation
        $(".bb-pro-variation-contant ul li").off("click").on("click", function () {
            $(this).addClass("active-variation").siblings().removeClass("active-variation");
        });

        // List Grid View
        $(".bb-bl-btn button").off("click").on("click", function () {
            $(this).addClass("active").siblings().removeClass("active");
        });
    }

    $(document).ready(function () {
        initShopUIHandlers();
    });

    // After any AJAX update that replaces sidebar/grid, call initShopUIHandlers();
    function showList100(e) {
        var $gridCont = $('.bb-shop-pro-inner');
        var $listView = $('.pro-bb-content');
        e.preventDefault();
        $gridCont.addClass('list-view-100');
        $listView.addClass('width-100');
    }

    function gridList100(e) {
        var $gridCont = $('.bb-shop-pro-inner');
        var $gridView = $('.pro-bb-content');
        e.preventDefault();
        $gridCont.removeClass('list-view-100');
        $gridView.removeClass('width-100');
    }

    $(document).on('click', '.btn-grid-100', gridList100);
    $(document).on('click', '.btn-list-100', showList100);

    /* coupon down box */
    $('.coupon-down-box').hide();
    $('.js-collection-filter, .js-price-range-form input').on('change', function () {
        var $grid = $('#collection-product-grid');
        var $sidebar = $('#collection-filters, #main-search');
        var $form = $(this).closest('form');
        var params = $form.serialize();
        var isSearchPage = $('#main-search-section').length > 0;
        var sectionId = isSearchPage ? 'main-search' : 'collection-filters';
        var url = window.location.pathname + '?' + params + '&section_id=' + sectionId;
        $grid.css('opacity', '0.5');
        fetch(url)
            .then(function (response) { return response.text(); })
            .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newGrid = doc.querySelector('#collection-product-grid');
                var newSidebar = doc.querySelector('#' + sectionId);
                if (!newSidebar) {
                    var noResultsMessage = document.createElement('div');
                    noResultsMessage.className = 'bb-no-results-message';
                    noResultsMessage.innerHTML = '<p>No products found matching filter.</p>';
                    const collectionProductGrid = document.querySelector('#' + sectionId);
                    collectionProductGrid.innerHTML = '';
                    collectionProductGrid.appendChild(noResultsMessage);
                    return;
                }
                if (newSidebar && $sidebar.length) {
                    $sidebar.html($(newSidebar).html());
                }
                if (window.AOS) {
                    setTimeout(function () {
                        if (typeof AOS.init === 'function') {
                            AOS.init();
                        } else if (typeof AOS.refresh === 'function') {
                            AOS.refresh();
                        }
                    }, 50);
                }
                initShopUIHandlers();
                $grid.css('opacity', '1');
                window.history.replaceState({}, '', url.replace('&section_id=' + sectionId, ''));
            });
    });

    /* Range slider */
    var $slider = $("#slider-range");
    if ($slider.length && typeof $slider.slider === 'function') {
        var min = parseInt($slider.data('min') == '' ? 0 : $slider.data('min'));
        var max = parseInt($slider.data('max') == '' ? 100 : $slider.data('max'));
        var currentMin = parseInt($slider.data('current-min') == '' ? min : $slider.data('current-min'));
        var currentMax = parseInt($slider.data('current-max') == '' ? max : $slider.data('current-max'));
        var $amount = $("#amount");
        var currencySymbol = $amount.data('currency-symbol');
        var $form = $slider.closest('.price-range-slider').find('.filter-form');
        $slider.slider({
            range: true,
            min: min,
            max: max,
            values: [currentMin, currentMax],
            slide: function (event, ui) {
                var format = currencySymbol + '{amount}';
                $amount.val(format.replace('{amount}', ui.values[0]) + ' - ' + format.replace('{amount}', ui.values[1]));
            },
            change: function (event, ui) {
                // Get the full query string
                const urlparams = new URLSearchParams(window.location.search);
                const q = urlparams.get('q');

                $form.find('input[name="filter.v.price.gte"]').val(ui.values[0]);
                $form.find('input[name="filter.v.price.lte"]').val(ui.values[1]);
                // AJAX filter fetch for both grid and sidebar
                var $grid = $('#collection-product-grid');
                var $sidebar = $('#collection-filters, #main-search');
                var $allForms = $('.bb-shop-wrap form');
                var params = $allForms.serialize();
                var isSearchPage = $('#main-search-section').length > 0;
                var sectionId = isSearchPage ? 'main-search' : 'collection-filters';
                var url = window.location.pathname + '?' + params + '&section_id=' + sectionId + '&q=' + q;
                $grid.css('opacity', '0.5');
                fetch(url)
                    .then(function (response) { return response.text(); })
                    .then(function (html) {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(html, 'text/html');
                        var newGrid = doc.querySelector('#collection-product-grid');
                        var newSidebar = doc.querySelector('#' + sectionId);
                        if (!newSidebar) {
                            var noResultsMessage = document.createElement('div');
                            noResultsMessage.className = 'bb-no-results-message';
                            noResultsMessage.innerHTML = '<p>No products found matching filter.</p>';
                            const collectionProductGrid = document.querySelector('#' + sectionId);
                            collectionProductGrid.innerHTML = '';
                            collectionProductGrid.appendChild(noResultsMessage);
                            return;
                        }
                        if (newSidebar && $sidebar.length) {
                            $sidebar.html($(newSidebar).html());
                        }
                        if (window.AOS) {
                            setTimeout(function () {
                                if (typeof AOS.init === 'function') {
                                    AOS.init();
                                } else if (typeof AOS.refresh === 'function') {
                                    AOS.refresh();
                                }
                            }, 50);
                        }
                        initShopUIHandlers();
                        $grid.css('opacity', '1');
                        window.history.replaceState({}, '', url.replace('&section_id=' + sectionId, ''));
                    });
            }
        });
        $amount.val(currencySymbol + $slider.slider('values', 0) + " - " + currencySymbol + $slider.slider('values', 1));
        $form.find('input[name="filter.v.price.gte"]').val($slider.slider('values', 0));
        $form.find('input[name="filter.v.price.lte"]').val($slider.slider('values', 1));
    }

    /* Shop sidebar JS */
    $(".btn-filter").on("click", function () {
        $(".bb-shop-overlay").fadeIn();
        $(".bb-shop-sidebar").addClass("bb-shop-sidebar-open");
    });

    $(".bb-shop-overlay, .filter-close").on("click", function () {
        $(".bb-shop-overlay").fadeOut();
        $(".bb-shop-sidebar").removeClass("bb-shop-sidebar-open");
    });

    /* back-to-top */
    $(window).scroll(function () {
        // console.log("scroll");
        if ($(this).scrollTop() > 50) {
            $(".back-to-top").fadeIn();
        } else {
            $(".back-to-top").fadeOut();
        }
    });

    var progressPath = document.querySelector('.back-to-top-wrap path');
    var pathLength = progressPath.getTotalLength();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
    progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
    progressPath.style.strokeDashoffset = pathLength;
    progressPath.getBoundingClientRect();
    progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
    var updateProgress = function () {
        var scroll = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        var progress = pathLength - (scroll * pathLength / height);
        progressPath.style.strokeDashoffset = progress;
    }
    updateProgress();
    $(window).scroll(updateProgress);
    var offset = 50;
    var duration = 550;
    jQuery(window).on('scroll', function () {
        if (jQuery(this).scrollTop() > offset) {
            jQuery('.back-to-top-wrap').addClass('active-progress');
        } else {
            jQuery('.back-to-top-wrap').removeClass('active-progress');
        }
    });
    jQuery('.back-to-top-wrap').on('click', function (event) {
        event.preventDefault();
        jQuery('html, body').animate({ scrollTop: 0 }, duration);
        return false;
    })

    /* Newsletter popup Homepage */
    setTimeout(function () {
        $(".bb-popnews-bg").fadeIn();
        $(".bb-popnews-box").fadeIn();
    }, 5000);

    $(".bb-popnews-close").click(() => {
        $(".bb-popnews-bg").fadeOut();
        $(".bb-popnews-box").fadeOut();
    });

    $(".bb-popnews-bg").click(() => {
        $(".bb-popnews-bg").fadeOut();
        $(".bb-popnews-box").fadeOut();
    });

    // Handle pagination
    $(document).on('click', '.js-pagination-link', function (e) {
        e.preventDefault();
        const link = e.currentTarget;
        const urlparams = new URLSearchParams(window.location.search);
        const q = urlparams.get('q');
        const linkUrl = new URL(link.href);
        const page = linkUrl.searchParams.get('page');

        // Get the section ID
        const proPagination = $(this).closest('.bb-pro-pagination');

        const sectionId = $(proPagination).data('section');
        const pagename = $(proPagination).data('pagename');

        const eleMainContainerId = `main-container-${sectionId}`;

        const eleMainContentId = `main-${pagename}-${sectionId}`;

        urlparams.set('page', page);
        // urlparams.set('section_id', sectionId);
        if (q) urlparams.set('q', q);
        const newUrl = window.location.pathname + '?' + urlparams.toString();
        window.history.pushState({}, '', newUrl);

        // Show loading state
        const $grid = $('#' + eleMainContainerId);
        const $content = $('#' + eleMainContentId);

        $grid.css('opacity', '0.5');

        // Fetch new content
        fetch(newUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newMainContent = doc.querySelector(`#${eleMainContentId}`);

                if (!newMainContent) {
                    var noResultsMessage = document.createElement('div');
                    noResultsMessage.className = 'bb-no-results-message';
                    noResultsMessage.innerHTML = '<p>No products found matching filter.</p>';
                    const collectionProductGrid = document.querySelector(`#${eleMainContainerId}`);
                    if (collectionProductGrid) {
                        collectionProductGrid.innerHTML = '';
                        collectionProductGrid.appendChild(noResultsMessage);
                    }
                    return;
                }

                if (newMainContent) {
                    $content.html($(newMainContent).html());
                }
                if (window.AOS) {
                    setTimeout(function () {
                        if (typeof AOS.init === 'function') {
                            AOS.init();
                        } else if (typeof AOS.refresh === 'function') {
                            AOS.refresh();
                        }
                    }, 50);
                }
                initShopUIHandlers();

                if ($grid) {
                    // Scroll to top of products
                    $('html, body').animate({
                        scrollTop: $grid.offset().top - 100
                    }, 500);

                    // Remove loading state
                    $grid.css('opacity', '1');
                }

                // Update URL without reload
                window.history.pushState({}, '', newUrl);
            });
    });

})(jQuery);
